// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2UVSe","Label":"styles_Label__1Hhr6","labelText":"styles_labelText__3CxQR","slice":"styles_slice__Njvf7"};